import { Check, Minus } from 'lucide-react';
import { siteData } from '../../data/mock';
import { useInView } from '../../hooks/useInView';

export const CategoryFrame = () => {
  const { categoryFrame } = siteData;
  const [ref, isInView] = useInView();

  return (
    <section className="py-[90px] lg:py-[110px] bg-[#faf9f6]">
      <div
        ref={ref}
        className={`max-w-[1200px] mx-auto px-6 lg:px-8 ${
          isInView ? 'animate-fade-in-up' : 'opacity-0'
        }`}
      >
        <h2 className="font-heading text-[1.85rem] lg:text-[2.5rem] font-bold text-stone-900 leading-[1.15] max-w-[580px] tracking-[-0.01em]">
          {categoryFrame.headline}
        </h2>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-6">
          {/* Booking-first */}
          <div className="p-7 rounded-2xl bg-stone-100/50 border border-stone-200/40">
            <h3 className="font-heading text-[1rem] font-semibold text-stone-400 mb-6 uppercase tracking-wide text-[0.75rem]">
              {categoryFrame.bookingFirst.title}
            </h3>
            <div className="space-y-4">
              {categoryFrame.bookingFirst.items.map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <Minus size={15} className="text-stone-300 flex-shrink-0" />
                  <span className="text-stone-400 text-[0.9rem]">
                    {item.label}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Operations-first */}
          <div className="p-7 rounded-2xl bg-white border border-[#2d6a5a]/12 shadow-[0_2px_12px_rgba(0,0,0,0.03)]">
            <h3 className="font-heading text-[1rem] font-semibold text-[#2d6a5a] mb-6 uppercase tracking-wide text-[0.75rem]">
              {categoryFrame.operationsFirst.title}
            </h3>
            <div className="space-y-4">
              {categoryFrame.operationsFirst.items.map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <div className="w-5 h-5 rounded-full bg-[#2d6a5a]/10 flex items-center justify-center flex-shrink-0">
                    <Check size={11} className="text-[#2d6a5a]" />
                  </div>
                  <span className="text-stone-700 text-[0.9rem] font-medium">
                    {item.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <p className="mt-9 text-[0.95rem] text-stone-500 max-w-[580px] leading-[1.7]">
          {categoryFrame.closing}
        </p>
      </div>
    </section>
  );
};
